$(document).ready(() => {

    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });
    $('[data-toggle="tooltip"]').tooltip();
    //=====menu mobile=========//
    $('[data-toggle]').on('click', function () {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $(
            '[data-toggle="showbox"][data-target="' + target_name + '"]'
        );
        if (toggle_name == 'openbox') {
            let target_status = target_element.data('status');
            $(
                '[data-toggle="showbox"]:not([data-target="' + target_name + '"])'
            ).attr('data-status', false);
            if (target_status == false) {
                target_element.attr('data-status', true);
            } else {
                target_element.attr('data-status', false);
            }
        } else if (toggle_name == 'closebox') {
            target_element.attr('data-status', false);
        }
    });
    $(document).on('click', function () {
        $('[data-toggle="showbox"]').attr('data-status', false);
    });
    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('[data-toggle="showbox"]').attr('data-status', false);
        }
    });
    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function (
        event
    ) {
        event.stopPropagation();
    });
    //=====end menu mobile======//

    //=================tab=================//
    $(document).on('click', '[data-tab]', function () {
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');
        $('[data-tab][data-tab-target="' + target + '"]').removeClass('active');
        $this.addClass('active');
        $('[data-tab-content][data-tab-target="' + target + '"]').removeClass(
            'active'
        );
        $(
            '[data-tab-content="' + tab + '"][data-tab-target="' + target + '"]'
        ).addClass('active');
    });
    //==================end tab================//

    //map
    if ($('#map').length > 0) {
        var mymap = L.map('map').setView([32.6538472, 51.6724925], 18);
        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'your.mapbox.access.token'
        }).addTo(mymap);

        var map_icon = L.icon({
            iconUrl: './assets/img/location.png',
            iconSize: [30, 42],
            iconAnchor: [30, 42],
            popupAnchor: [0, -40]
        });
        var marker = L.marker([32.6538472, 51.6724925], { icon: map_icon, }).addTo(mymap);
    }

    //


    //========== slider ==============//
    var categories_slider = new Swiper('.categories__wrapper .swiper', {
        spaceBetween: 20,
        slidesPerView: 2,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        breakpoints: {
            1200: {
                slidesPerView: 7,
            },
            992: {
                slidesPerView: 6,
            },
            768: {
                slidesPerView: 4,
            },
            480: {
                slidesPerView: 3,
            },
        },
    });
    $(document).on('mouseover', '.categories__wrapper__item', function () {
        if (categories_slider.length > 1) {
            $.each(categories_slider, function (i) {
                categories_slider[i].autoplay.stop();
            })
        }
        else {
            categories_slider.autoplay.stop();
        }
    })
    $(document).on('mouseleave', '.categories__wrapper__item', function () {
        if (categories_slider.length > 1) {
            $.each(categories_slider, function (i) {
                categories_slider[i].autoplay.start();
            })
        }
        else {
            categories_slider.autoplay.start();
        }
    })







    var product_slider = new Swiper('.product-slider__swiper .swiper', {
        spaceBetween: 25,
        slidesPerView: 1,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },
        navigation: {
            prevEl: '.product-slider__swiper .swiper-btn-next',
            nextEl: '.product-slider__swiper .swiper-btn-prev',
        },

        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            480: {
                slidesPerView: 1,
            },
        },
    });


    var cat_slider = new Swiper('.swiper-landing', {
        spaceBetween: 25,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        pagination: {
            el: '.pagination-post-slide',
        },
        breakpoints: {
            1200: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            480: {
                slidesPerView: 1.5,
            },
        }
    });



    var intro_slider = new Swiper('.intro__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        pagination: {
            el: '.intro__slider .swiper-pagination',
        },
    });


    var products_slider = new Swiper('.products-slider__wrapper .swiper', {
        spaceBetween: 30,
        slidesPerView: 2,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        navigation: {
            nextEl: '.products-slider__wrapper__pagination .swiper-btn-prev',
            prevEl: '.products-slider__wrapper__pagination .swiper-btn-next',
        },

        breakpoints: {
            1200: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            480: {
                slidesPerView: 2,
            },
        },

    });


    var product_discount = new Swiper('.product-discount__wrapper .swiper', {
        spaceBetween: 25,
        slidesPerView: 1,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: 0,
        // },
        navigation: {
            nextEl: '.product-discount__wrapper .swiper-btn-prev',
            prevEl: '.product-discount__wrapper .swiper-btn-next',
        },
        breakpoints: {
            1200: {
                slidesPerView: 3.4,
            },
            992: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 1.5,
            },
            430: {
                slidesPerView: 1.5,
            },
        },
    });


    var blog_slider = new Swiper('.blog__wrapper .swiper', {
        spaceBetween: 0,
        loop: true,
        slideToClickedSlide: 1,
        simulateTouch: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        navigation: {
            nextEl: '.blog__wrapper .swiper-btn-prev',
            prevEl: '.blog__wrapper .swiper-btn-next',


        },
        breakpoints: {
            1200: {
                slidesPerView: "auto",
            },
            992: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
        },
        on: {
            init: function (e) {
                e.update();
            },
            resize: function (e) {
                e.update();
            },
            beforeResize: function (e) {
                e.update();
            },
            slideChange: function (e) {
                e.update();
            },

        },

    });


    var products = new Swiper('.products__wrapper__slider .swiper', {
        spaceBetween: 10,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        breakpoints: {
            1200: {
                spaceBetween: 20,
                slidesPerView: 5.6,
            },
            992: {
                slidesPerView: 4.6,
            },
            768: {
                slidesPerView: 3.3,
            },
            576: {
                slidesPerView: 2,
            },
            480: {
                slidesPerView: 1.5,
            },
        },
    });


    var list_slider = new Swiper('.single-product__wrapper__slider__list-slider .swiper', {
        direction: 'horizontal',
        slidesPerView: 3,
        spaceBetween: 10,

        slideToClickedSlide: true,
        clickable: true,
        breakpoints: {
            992: {

                direction: 'horizontal',
                slidesPerView: 4,
                spaceBetween: 30,
            },
            480: {
                direction: 'vertical',
                spaceBetween: 10,
                slidesPerView: 4,
            },
        },
    });

    $('.single-product__wrapper__slider__list-slider__item').on('click', function () {
        $('.single-product__wrapper__slider__list-slider__item.active').removeClass('active');
        $(this).addClass('active')
    });




    $(document).on("click", ".single-product__wrapper__slider__list-slider__item img", function () {
        let img_src = $(this).data("src");
        $(this).closest(".single-product__wrapper__slider").find(".single-product__wrapper__slider__image img").attr("src", img_src);
        let data_zoom_image = $(this).data("zoom-image");
        xoriginal = $(this).closest(".single-product__wrapper__slider").find(".single-product__wrapper__slider__image img").attr("xoriginal", data_zoom_image);
    })


    var list_slider = new Swiper('.cat-group__slider .swiper', {
        direction: 'horizontal',
        slidesPerView: 4.4,
        spaceBetween: 20,
        slideToClickedSlide: true,
        breakpoints: {
            1200: {

                direction: 'horizontal',
                slidesPerView: 4.4,
            }, 992: {

                direction: 'horizontal',
                slidesPerView: 3,
            }, 768: {

                direction: 'horizontal',
                slidesPerView: 2.5,
            },
            480: {
                // direction: 'vertical',
                slidesPerView: 2.5,
            },
            400: {
                // direction: 'vertical',
                slidesPerView: 1.5,
            }, 300: {
                // direction: 'vertical',
                slidesPerView: 1.25,
            },
        },
    });

    $(document).on("click", ".single-product__wrapper__slider__list-slider__item img", function () {
        let img_src = $(this).data("src");
        $(this).closest(".single-product__wrapper__slider").find(".single-product__wrapper__slider__image img").attr("src", img_src);
        let data_zoom_image = $(this).data("zoom-image");
        xoriginal = $(this).closest(".single-product__wrapper__slider").find(".single-product__wrapper__slider__image img").attr("xoriginal", data_zoom_image);
    })
    //==============end slider===============//
    //xzoom//
    const xzoom = () => {
        if ($(".xzoom").length) {
            if ($(window).outerWidth() >= 1200) {
                instance = $(".xzoom").xzoom({ Xoffset: -1050, Yoffset: -110, zoomWidth: "600", zoomHeight: "460" });
                console.log("1500 hastam");
            }
            else if ($(window).outerWidth() < 1200 && $(window).outerWidth() >= 992) {

                $(".xzoom").xzoom({ Xoffset: -800, Yoffset: -110, zoomWidth: "400", zoomHeight: "400" });
                console.log("1200 hastam")
            }
        }
    }
    if ($(".xzoom").length) {
        xzoom();
    }
    $(window).resize(function () {
        xzoom();
    });

    //end xzoom//
    //sidebar category//
    $(".sidebar__wrapper__cat__item__title").on("click", function () {
        let $this = $(this);
        $this.closest(".sidebar__wrapper__cat__item").find(".sidebar__wrapper__cat__item__content").toggleClass("active");
    })
    $(".sidebar__wrapper__filter > ul > li > i").on("click", function () {
        $(this).closest('.sidebar__wrapper__filter > ul > li').remove();
    })
    $(".sidebar__wrapper__title__heading:not(.sidebar__wrapper__title__heading--red)").on("click", function () {
        $(this).closest(".sidebar__wrapper__title").toggleClass("active");
        if ($(this).closest("sidebar__wrapper").has(".sidebar__wrapper__cat")) {
            $(this).closest(".sidebar__wrapper").find(".sidebar__wrapper__cat").slideToggle(300);
        }
        if ($(this).closest("sidebar__wrapper").has(".sidebar__wrapper__price")) {
            $(this).closest(".sidebar__wrapper").find(".sidebar__wrapper__price").slideToggle(300);
        }
        if ($(this).closest("sidebar__wrapper").has(".sidebar__wrapper__berand")) {
            $(this).closest(".sidebar__wrapper").find(".sidebar__wrapper__berand").slideToggle(300);
        }
    })
    // end sidebar category//
    //============color===============//
    $('[data-color]').each((i, e) => {
        let color = $(e).data('color');
        $(e).css('background-color', color)
    })
    //=============end color===========//

    //scrool//
    $(".sidebar__wrapper__berand").mCustomScrollbar({
        theme: "minimal-dark",
        scrollInertia: 400
    });
    $(".sidebar__wrapper__cat").mCustomScrollbar({
        theme: "minimal-dark",
        scrollInertia: 400
    });
    $(".compare-modal__product").mCustomScrollbar({
        theme: "minimal-dark",
        scrollInertia: 400
    });
    //end scrool//
    //reng price//
    if ($(".sidebar__wrapper__price").length) {
        var price = document.getElementById('price');
        noUiSlider.create(price, {
            start: [150000, 5050000],
            connect: true,
            behaviour: 'tap',
            direction: 'rtl',
            range: {
                'min': [100000],
                '10%': [200000],
                '50%': [400000],
                'max': [6000000]
            },
            format: wNumb({
                decimals: 0,
                thousand: ','
            })
        });
        var nodes = [
            document.getElementById('lower-value'),
            document.getElementById('upper-value')
        ];
        price.noUiSlider.on('update', function (values, handle, unencoded, isTap, positions) {
            nodes[handle].innerHTML = values[handle];
        });
    }
    //end reng price//
    //=============search=================//
    $(document).on("keyup", ".sidebar__wrapper__title__search input", function () {
        var val = $(this).val();
        if (val.length > 0) {
            $(".sidebar__wrapper__cat__item").addClass("sidebar__wrapper__cat__item--search");
        }
        else {
            $(".sidebar__wrapper__cat__item").removeClass("sidebar__wrapper__cat__item--search");
        }
        $(this).closest('.sidebar__wrapper').find('.sidebar__wrapper__cat__item__content > ul > li > a').each(function () {
            if ($(this).text().toLowerCase().search(val.toLowerCase()) > -1) {
                $(this).parent().removeClass('no-result');
            }
            else {
                $(this).parent().addClass('no-result');
            }
        });
    })
    $(document).on("keyup", ".sidebar__wrapper__title__search input", function () {
        var val = $(this).val();
        $(this).closest('.sidebar__wrapper').find('.sidebar__wrapper__berand ul li ').each(function () {
            if ($(this).text().toLowerCase().search(val.toLowerCase()) > -1) {
                $(this).removeClass('no-result');
            }
            else {
                $(this).addClass('no-result');
            }
        });
    })


    $(document).on("keyup", ".compare-modal__search input", function () {
        var val = $(this).val();
        $(this).closest('.compare-modal').find('.compare-modal__product__item').each(function () {

            if ($(this).text().toLowerCase().search(val.toLowerCase()) > -1) {
                $(this).removeClass('no-result');
            }
            else {
                $(this).addClass('no-result');
            }
        });
    })

    //=============end search=================//

    $(".product__item__arrived").each(function (i, e) {

        var start_time = new Date($(e).data('start')),
            finish_time = new Date($(e).data('finish'))

        $(e).find(".timer").countdown(finish_time, function (event) {

            var current_time = new Date(),
                per_time = 100 / (Math.abs(finish_time - start_time) / 1000),
                pass_time = (Math.abs(current_time - start_time) / 1000) * per_time;

            if (finish_time > current_time && current_time > start_time) {
                var format = '%M : %S';

                if (event.offset.hours > 0) {
                    format = '%H : ' + format;
                }
                if (event.offset.days > 0) {
                    format = '%D : ' + format;
                }

                $(e).find(".product__item__arrived__title span").html(event.strftime(format));
                $(e).find(".product__item__arrived__progressbar__development").css("width", pass_time + '%');

            }

        });
    })
    //=======countdowun=====//
    // $(".product__item__arrived").each(function (i, e) {
    //     var date_finish = new Date($(e).data('finish'));
    //     var data_start = new Date($(e).data('start'));
    //     var left_over = (date_finish.getTime() - data_start.getTime()) / 1000;
    //     $(e).find(".timer").countdown(date_finish, function (event) {
    //         var development = (100 - ((event.offset.totalSeconds * 100) / left_over));
    //         var format = '%M : %S';

    //         if (event.offset.hours > 0) {
    //             format = '%H : ' + format;
    //         }
    //         if (event.offset.days > 0) {
    //             format = '%D : ' + format;
    //         }
    //         $(e).find(".product__item__arrived__title span").html(event.strftime(format));
    //         $(e).find(".product__item__arrived__progressbar__development").css("width", development);
    //     });

    // })



    // $(".single-product__wrapper__content__bottom__arrived").each(function (i, e) {
    //     var date_finish = new Date($(e).data('finish'));
    //     var data_start = new Date($(e).data('start'));
    //     var left_over = (date_finish.getTime() - data_start.getTime()) / 1000;
    //     $(e).find(".timer").countdown(date_finish, function (event) {
    //         var development = (100 - ((event.offset.totalSeconds * 100) / left_over));
    //         $(e).find(".single-product__wrapper__content__bottom__arrived__title span").html(
    //             event.strftime(`
    //                 <div class="span"><span>%S</span><span>ثانیه</span></div>
    //                 <div class="span"><span>%M</span><span>دقیقه</span></div>
    //                 <div class="span"><span>%H</span><span>ساعت</span></div>
    //                 <div class="span"><span>%D</span><span>روز</span></div>

    //                 `)
    //         );
    //         $(e).find(".single-product__wrapper__content__bottom__arrived__title span").html(event.strftime(format));
    //         $(e).find(".single-product__wrapper__content__bottom__arrived__progressbar__development").css("width", pass_time + '%');
    //     });

    // });



    $(".single-product__wrapper__content__bottom__arrived").each(function (i, e) {

        var start_time = new Date($(e).data('start')),
            finish_time = new Date($(e).data('finish'))

        $(e).find(".timer").countdown(finish_time, function (event) {

            var current_time = new Date(),
                per_time = 100 / (Math.abs(finish_time - start_time) / 1000),
                pass_time = (Math.abs(current_time - start_time) / 1000) * per_time;

            if (finish_time > current_time && current_time > start_time) {
                var format = '%M : %S';

                if (event.offset.hours > 0) {
                    format = '%H : ' + format;
                }
                if (event.offset.days > 0) {
                    format = '%D : ' + format;
                }
            
                $(e).find(".single-product__wrapper__content__bottom__arrived__title span").html(event.strftime(format));
                $(e).find(".single-product__wrapper__content__bottom__arrived__progressbar__development").css("width", pass_time + '%');

            }

            $(e).find(".single-product__wrapper__content__bottom__arrived__title span").html(
                event.strftime(`
                <div class="span"><span>%S</span><span>ثانیه</span></div>
                <div class="span"><span>%M</span><span>دقیقه</span></div>
                <div class="span"><span>%H</span><span>ساعت</span></div>
                <div class="span"><span>%D</span><span>روز</span></div>
              
               
                    `)
            );

        });
    })




    //=========end countdowun=========//
    //=========star====================//
    $(document).on("mouseover", ".single-product__wrapper__content__title__score__star label", function () {
        $this = $(this);
        let data_number = $this.data("number");
        $this.closest(".single-product__wrapper__content").find(".single-product__wrapper__content__title__score__text span").html(data_number);
    })
    //====================  end star  ====================//

    //==================== plus or minus product ====================//
    //=========  end star====================//
    // plus or minus product//
    $(document).on("click", ".single-product__wrapper__content__bottom__buy__button__count i", function () {
        var $this = $(this),
            type = $this.attr("data-type"),
            input = $this.closest(".single-product__wrapper__content__bottom__buy__button__count").find("input"),
            value = parseInt(input.val()),
            min = input.attr('min'),
            max = input.attr('max'),
            number = $this.closest(".single-product__wrapper__content__bottom__buy__button__count").find("span");
        if (type == "minus") {
            if (value > min) {
                value--;
            }
        }
        else if (type == "plus") {
            if (value < max) {
                value++;
            }
        }
        number.html(value);
        input.val(value);
    })
    // end plus or minus product//


    //==================== remove compair ====================//

    $(".content-compare__product__icon").on("click", function () {

        let $this = $(this),
            tab = $this.data('id');
        $(`.content-compare__table [data-attr-id="${tab}"]`).html('');

        $(this).closest('.content-compare__product').parent().remove();
    });

    //==================== end remove compair ====================//


    //=======select=====//
    $(document).on("click", ".content-compare__add", function () {

        if ($(this).hasClass('active')) {
            $(this).removeClass("content-compare__add--active");
        }
        else {
            $(this).addClass("content-compare__add--active");
        }
        $(document).on("click", ".compare-modal__product__item", function () {
            var img = $(this).closest('.compare-modal__product__item').find('.compare-modal__product__item__content__img img');
            var text = $(this).closest('.compare-modal__product__item').find('.compare-modal__product__item__content__text span');
            console.log($(text));
        })
    })
    //=======end select=====//



    //===============add==============//

    $('.compare - modal__product__item').on('click', function () {
        var img_src = $(this).data('image-src');
        var title = $(this).data('title');

        if (img_src.length > 1) {
            $('.content-compare__add').remove('hide');
            // $('.content-compare__product').add();
        }
        // else ()
    });
    //===============end add==============//



    var intro_slider = new Swiper('.cat-landing__row__swiper__slider .swiper', {
        spaceBetween: 30,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,
        },
        pagination: {
            el: '.cat-landing__row__swiper__slider .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            1200: {
                spaceBetween: 30,
                slidesPerView: 1,
            },
            992: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 1,
            },
        },

    });

    $(".submit-comment__wrapper__content__submit__form form .form-group > ul > li > a > i").on("click", function () {
        $(this).closest('.submit-comment__wrapper__content__submit__form form .form-group > ul > li').remove();
    });


    //nouislider:page single-product
    $.each($('.slider-step'), (i, e) => {

        let single_slider = noUiSlider.create(e, {
            start: [0],
            step: 25,
            connect: 'lower',
            direction: 'rtl',

            range: {
                'min': 0,
                'max': 100
            }
        });
        // uislider.push(single_slider);
        e.noUiSlider.on('change', function (values, handle) {
            let $this = $(this.target);
            console.log($this.closest('li'));
            let span = $(this.target).find('.submit-comment__wrapper__content__product__specification__content-menu__nouislider__step span');
            var val = parseInt(values[0]);
            span.each(function (index, el) {
                let bullets = $(el);
                let rate = bullets.attr('data-rate');
                if (parseInt(rate) <= val) {
                    $this.closest('li').find('.submit-comment__wrapper__content__product__specification__content-menu__head__score span').text(bullets.attr('data-title'));
                    bullets.addClass('active');
                } else {
                    bullets.removeClass('active');
                }
            })
        });

    });

    $("document").on('click', '.sss', e => {
        let $this = $(e.currentTarget),
            rate = $this.attr('data-rate-value');
        stepSlider.noUiSlider.set(rate);

        $this.siblings().map(item => {
            let sibRate = item.attr('data-rate-value')
            if (rate <= sibRate) {
                item.addClass('active')
            }
            else {
                item.removeClass('active')
            }
        })
    })



    // var connectSlider = document.getElementById('slider-step');

    // noUiSlider.create(connectSlider, {

    //     start: [0],
    //     step: 25,
    //     connect: 'lower',


    //     range: {
    //         'min': 0,
    //         'max': 100
    //     }
    // });

    //zoom-swiper



    //


});